module.exports = __webpack_public_path__ + "static/img/tf02.2f3fa43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tf02.png
// module id = eE4m
// module chunks = 0